import { PageLoansPaymentCreate } from './Create';
import { PageLoansPaymentOverview } from './Overview';
import { PageLoansPaymentView } from './View';

export const PAYMENTS = {
  LoansPaymentView: PageLoansPaymentView,
  LoansPaymentCreate: PageLoansPaymentCreate,
  LoansPaymentOverview: PageLoansPaymentOverview,
} as const;
